var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Box, Button, Card, Flex, Image, Link, Text, ChatMessage } from 'pcln-design-system';
import { HotelFilterComponent } from './HotelFilterComponent';
import styled from 'styled-components';
import { TravelBotLogoImage } from '../TravelBotLogoImage';
var StyledImage = styled(Image)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-bottom-left-radius: 16px;\n  border-top-left-radius: 16px;\n"], ["\n  border-bottom-left-radius: 16px;\n  border-top-left-radius: 16px;\n"])));
export var HotelDetailCard = function (props) {
    var detailURL = "/relax/at/".concat(props.hotelId, "/from/").concat(props === null || props === void 0 ? void 0 : props['check-in'], "/to/").concat(props === null || props === void 0 ? void 0 : props['check-out'], "/rooms/").concat(props.rooms, "/adults/").concat(props === null || props === void 0 ? void 0 : props['adult-occ']);
    return (React.createElement(Card, { m: 3, bg: 'white', borderRadius: 'xl' },
        React.createElement(Flex, null,
            React.createElement(Box, null,
                React.createElement(StyledImage, { src: props.thumbnailUrl, width: '90px' })),
            React.createElement(Box, { p: 2 },
                React.createElement(Text, { textStyle: 'paragraphBold' }, props.name),
                React.createElement(Flex, null,
                    React.createElement(Text.span, { fontSize: 1, mr: 1 },
                        props.overallGuestRating,
                        " Guest Rating"),
                    React.createElement(Text.span, { fontSize: 1 },
                        "(",
                        props.totalReviewCount,
                        " Reviews)")),
                React.createElement(Button, { variation: 'link' },
                    React.createElement(Link, { href: detailURL, target: '_blank' }, "View Hotel Details"))))));
};
export var HotelDetailCardsMessage = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var highRatedHotels = (_b = (_a = props.searchResult) === null || _a === void 0 ? void 0 : _a.hotels) === null || _b === void 0 ? void 0 : _b.filter(function (hotel) { return hotel.overallGuestRating > 7.5; });
    var displayResult = (highRatedHotels === null || highRatedHotels === void 0 ? void 0 : highRatedHotels.length)
        ? (_d = (_c = props.searchResult) === null || _c === void 0 ? void 0 : _c.hotels) === null || _d === void 0 ? void 0 : _d.filter(function (hotel) { return hotel.overallGuestRating > 7.5; })
        : (_e = props.searchResult) === null || _e === void 0 ? void 0 : _e.hotels;
    return (React.createElement(React.Fragment, null,
        React.createElement(ChatMessage, { mb: '40px', ml: '', variation: 'initial', Icon: TravelBotLogoImage, message: React.createElement(Box, null,
                React.createElement(Text, null, "Here are some of the top guest-rated hotels for your consideration:"), (_f = displayResult === null || displayResult === void 0 ? void 0 : displayResult.slice(0, 3)) === null || _f === void 0 ? void 0 :
                _f.map(function (hotel) { return (React.createElement(React.Fragment, { key: String(hotel.hotelId) },
                    React.createElement(HotelDetailCard, __assign({}, hotel, props === null || props === void 0 ? void 0 : props.args)))); }),
                React.createElement(HotelFilterComponent, __assign({}, props))) })));
};
var templateObject_1;
//# sourceMappingURL=HotelDetailCard.js.map